import Vue from "vue";

const state = {
  user_transactions: [],
  totalAmountTransactions: 0,
  loading: true
};
const getters = {
  user_transactions: state => {
    return state.user_transactions;
  },
  totalAmountTransactions: state => {
    return state.totalAmountTransactions;
  },
  loading: state => {
    return state.loading;
  }
};

const actions = {
  transactions(context, payload) {
    return Vue.prototype.$http.get("/api/transactions/v1" + payload);
  },
  getTransaction(context, payload) {
    return Vue.prototype.$http.get("/api/transactions/v1/" + payload.id);
  }
};

const mutations = {
  user_transactions(state, payload) {
    state.user_transactions = payload;
  },
  loading(state, payload) {
    state.loading = payload;
  },
  totalAmountTransactions(state, payload) {
    state.totalAmountTransactions = payload;
  }
};

export const transactions = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
